import Alert from "@/components/ui/alert";

export default function AppError() {
  return (
    <div className="w-full h-screen flex flex-col items-center justify-center">
      <div className="w-fit mx-auto">
        <Alert
          variant="destructive"
          className="w-fit"
          title="Unable to fetch app"
          description="An error occurred while fetching the app. Please try again later."
        />
      </div>
    </div>
  );
}
